<template>
  <div class="product-pile1">
    <div class="product1">
      <img :src="require(is1920 ? '../assets/productp11.png' : '../assets/product2880p11.png')"/>
    </div>
    <div class="product2">
      <img :src="require(is1920 ? '../assets/productp12.png' : '../assets/product2880p12.png')"/>
      <div class="desc">
        <p>国恒充电智慧交流充电桩</p>
        <p>GHJ220032B-3/4G</p>
        <p>坚韧 成熟 品质</p>
      </div>
    </div>
    <div class="product3">
      <img :src="require(is1920 ? '../assets/productp13.png' : '../assets/product2880p13.png')"/>
      <div class="desc">
        <div>
          <p>ST芯片，168MHz</p>
          <p>主芯片</p>
        </div>
        <div>
          <p>-20℃~50℃</p>
          <p>工作温度</p>
        </div>
        <div>
          <p>32A 七孔</p>
          <p>输出端</p>
        </div>
      </div>
    </div>
    <div class="product4">
      <div class="table">
        <div class="tr">
          <div>外观尺寸</div>
          <div>260mm*260mm*99mm</div>
        </div>
        <div class="tr">
          <div>输入电压</div>
          <div>176V～264V AC</div>
        </div>
        <div class="tr">
          <div>工作频率</div>
          <div>50Hz±5Hz</div>
        </div>
        <div class="tr">
          <div>额定电流</div>
          <div>32A</div>
        </div>
        <div class="tr">
          <div>额定功率</div>
          <div>7kW</div>
        </div>
        <div class="tr">
          <div>充电方式</div>
          <div>二维码</div>
        </div>
        <div class="tr">
          <div>充电接口</div>
          <div>充电枪（GB/T 20234.2-2015）</div>
        </div>
        <div class="tr">
          <div>枪线长度</div>
          <div>3米</div>
        </div>
        <div class="tr">
          <div>显示屏</div>
          <div>无</div>
        </div>
        <div class="tr">
          <div>安装方式</div>
          <div>壁挂/立柱</div>
        </div>
        <div class="tr">
          <div>工作环境</div>
          <div>－20℃～＋50℃  相对湿度5%～95%</div>
        </div>
        <div class="tr">
          <div>储存环境</div>
          <div>－40℃～＋85℃  相对湿度10%～95%</div>
        </div>
        <div class="tr">
          <div>海拔高度</div>
          <div>≤2000米</div>
        </div>
        <div class="tr">
          <div>适用场景</div>
          <div>户内户外</div>
        </div>
        <div class="tr">
          <div>安全保护</div>
          <div>漏电（外置）、过流、欠压、过压、板载防浪涌、接地</div>
        </div>
        <div class="tr">
          <div>IP等级</div>
          <div>IP55</div>
        </div>
        <div class="tr">
          <div>有序充电功能</div>
          <div>支持</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'productBox',
  inject: ['is1920']
}
</script>
<style lang="less">
.product-pile1{
  background-color: white;
  width: 100%;
  >div{
    position: relative;
    height: 6rem;
    margin: 0;
  }
  p{
    margin: 0;
    text-align: left;
  }
  .product2{
    height: 8.34rem;
    .desc{
      position: absolute;
      top: 1.78rem;
      left: 3.64rem;
      p{
        color: #000;
        &:nth-child(1){
          font-size: .48rem;
          line-height: .67rem;
          margin-bottom: .1rem;
        }
        &:nth-child(2){
          font-size: .38rem;
          line-height: .53rem;
          margin-bottom: .4rem;
        }
        &:nth-child(3){
          color: #13E4E8;
          font-size: .32rem;
          line-height: .45rem;
        }
      }
    }
  }
  .product3{
    height: 10.4rem;
    .desc{
      position: absolute;
      width: 19.2rem;
      top: 1.25rem;
      display: flex;
      padding-left: 3.46rem;
      >div{
        p{
          text-align: center;
          &:first-child{
            font-size: .50rem;
            line-height: .70rem;
            color: #fff;
          }
          &:last-child{
            font-size: .24rem;
            line-height: .33rem;
            color: #fff;
            opacity: .6;
          }
        }
        &:nth-child(1){
          padding: 0 .85rem 0 0;
        }
        &:nth-child(2){
          padding: 0 .72rem;
          border-left: 1px rgba(255, 255, 255, .6) solid;
          border-right: 1px rgba(255, 255, 255, .6) solid;
        }
        &:nth-child(3){
          padding: 0 0 0 .85rem;
        }
      }
    }
  }
  .product4{
    height: 12rem;
    min-height: 11.50rem;
    width: 12rem;
    margin: .45rem auto 0;
    .table{
      border: 1px solid #979797;
      .tr{
        display: flex;
        align-items: center;
        &:not(:last-child) {
          border-bottom: 1px solid #979797;
        }
        >div{
          color: #333;
          font-size: .28rem;
          line-height: .40rem;
          &:nth-child(1){
            width: 2.36rem;
            text-align: center;
            padding: .13rem 0;
          }
          &:nth-child(2){
            border-left: 1px solid #979797;
            width: 9.64rem;
            text-align: left;
            padding: .13rem .6rem;
            word-break:break-all;
          }
        }
      }
    }
  }
  img{
    width: 100%;
    height: 100%;
  }
}
</style>
